{
  "availability": "Montag bis Freitag, 8:30 – 17:00 Uhr",
  "facebook_messenger": "Facebook Messenger",
  "inselhuepfen": {
    "availability": "Sie erreichen uns von Montag bis Freitag<br>09:00 bis 12:30 Uhr / 14:00 bis 17:00 Uhr",
    "faqs": "Unsere FAQ's",
    "faqs_url": "https://www.inselhuepfen.com/gut-zu-wissen",
    "phone_numbers": "+49 (0) 7531 / 361860",
    "send_us_a_message_url": "https://www.inselhuepfen.com/kontakt",
    "title": "Noch Fragen?"
  },
  "kootstra": {
    "title": "Haben Sie Fragen?",
    "availability": "Unsere Öffnungszeiten:<br>\nMontag – Freitag<br>\n9:00 – 17:00 Uhr",
    "phone_availability": "9:00-11:00 und 13:00-16:00\u00A0Uhr",
    "phone_numbers": "+49 (0) 251-518161",
    "email_address": "reisen@kootstra.de",
    "email_us": "Senden Sie uns eine E-Mail"
  },
  "phone_numbers": "+49 2102 42 0655 (DE)",
  "send_us_a_message": "Senden Sie uns eine Nachricht",
  "send_us_a_message_url": "https://www.boatbiketours.de/kontakt/#contact_form",
  "start_a_live_chat": "Live-Chat starten",
  "title": "Fragen?"
}
